import React from "react";
import { X } from "react-bootstrap-icons";
import { FcGoogle } from "react-icons/fc";
import clsx from "clsx";
import useOneTapAuth from "@/hooks/useOneTapAuth";
import { MIXPANEL_REGISTER_LOCATION_GOOGLE_ONE_TAP_MODAL } from "@/constants/mixpanel.constants";

interface OneTapSignInDrawerProps {
    show: boolean;
    onClose: () => void;
    redirectPath?: string;
    version?: string;
    location?: string;
}

/**
 * OneTapSignInDrawer – streamlined mobile sign-in drawer (Google only, single Continue).
 */
const OneTapSignInDrawer: React.FC<OneTapSignInDrawerProps> = ({
    show,
    onClose,
    redirectPath = "/puzzle",
    version = "puzzle",
    location = MIXPANEL_REGISTER_LOCATION_GOOGLE_ONE_TAP_MODAL,
}) => {
    const { shouldShow, handleGoogle } = useOneTapAuth({ redirectPath, version, onClose, location });

    if (!shouldShow) {
        return null;
    }

    return (
        <div
            className={clsx(
                "tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-bg-[#111111] tw-rounded-t-3xl tw-shadow-2xl tw-transition-transform tw-duration-300 tw-z-[100] tw-max-h-[80vh] tw-overflow-y-auto",
                show ? "tw-translate-y-0" : "tw-translate-y-full"
            )}
        >
            <div className="tw-px-4 tw-pt-4 tw-pb-4">
                <button
                    onClick={onClose}
                    className="tw-absolute tw-bg-transparent tw-border-0 tw-p-1 tw-rounded-full tw-top-4 tw-right-4 tw-text-gray-400 hover:tw-text-gray-200 tw-transition-colors"
                    aria-label="Close"
                >
                    <X className="tw-w-5 tw-h-5" />
                </button>

                <div className="tw-flex tw-items-center tw-gap-2 tw-mb-4">
                    <FcGoogle className="tw-w-[25px] tw-h-[25px] tw-shrink-0 tw-mr-1" />
                    <p
                        className="tw-m-0 tw-text-white"
                        style={{ fontSize: 16, fontWeight: 600, fontFamily: "Inter, sans-serif" }}
                    >
                        Sign in to PriceMe with Google
                    </p>
                </div>

                <button
                    onClick={handleGoogle}
                    className="tw-w-full tw-min-h-[44px] tw-h-11 tw-bg-[#2f80ff] tw-text-white tw-rounded-2xl hover:tw-opacity-90 tw-transition tw-flex tw-items-center tw-justify-center tw-text-sm tw-font-noto"
                >
                    Continue
                </button>
            </div>
        </div>
    );
};

export default OneTapSignInDrawer;
